import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import {
  BonusApi,
  get,
  SiteConfigManager,
  useApplicationState,
  useSettings,
} from '@atlas/core';
import { CLIENT_PROFILE_COMPONENT_TYPES, COMPONENT_TYPES } from '@atlas/routing';
import { EmptyStateView, Loader } from '@atlas/ui';

import { freebetStatusOrder } from 'common/constants';
import FreeBetsTableItem from 'components/ClientProfile/Bonuses/FreeBets/FreeBetsTableItem';

import SeoPageText from '../../../SeoPage/SeoPageText';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { BONUSES } = CLIENT_PROFILE_COMPONENT_TYPES;

export const sortFreeBetsList = freeBetsList =>
  [...freeBetsList].sort(
    (a, b) =>
      (freebetStatusOrder[a?.status] ?? Number.MAX_SAFE_INTEGER) -
      (freebetStatusOrder[b?.status] ?? Number.MAX_SAFE_INTEGER),
  );

const FreeBets = () => {
  const applicationState = useApplicationState();
  const { wallet: { currency } = {} } = applicationState;
  const { lang } = useSettings();

  const clientProfileTabs = get(SiteConfigManager.getComponentOptions(CLIENT_PROFILE), 'tabs');
  const hideSportBonuses = SiteConfigManager.getConfig('config.config.general.hideSportBonuses');
  const bonusesOptions = clientProfileTabs.find(({ type }) => type === BONUSES);

  const { isExpandedOnMobile } = bonusesOptions;

  const enableFooterForAllPages = SiteConfigManager.getConfig(
    'config.config.general.enableFooterForAllPages',
  );

  const [freeBetsList, setFreeBetsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { freeBets } = await BonusApi.getFreebetBonuses({
          country: 'test',
          currency,
          language: lang.toUpperCase(),
        });
        const list = sortFreeBetsList(freeBets);
        setFreeBetsList(list);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const isAddBottomSpace = !enableFooterForAllPages && (!isExpandedOnMobile || hideSportBonuses);

  if (isLoading) {
    return <Loader className="relative" />;
  }

  if (freeBetsList.length === 0) {
    return (
      <>
        <EmptyStateView
          className="empty-center"
          description="account_freebet_bonuses_empty_description"
          title="account_freebet_bonuses_empty_title"
        />
        <SeoPageText />
      </>
    );
  }

  return (
    <div className={cx('bonus-history-list', isAddBottomSpace && 'hidden-footer')}>
      {freeBetsList.map(freeBet => (
        <FreeBetsTableItem freeBet={freeBet} key={freeBet.id} />
      ))}
      <SeoPageText />
    </div>
  );
};

export default FreeBets;
